var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"editor",staticClass:"w-100",attrs:{"id":"json-editor"}})
}
var staticRenderFns = []

export { render, staticRenderFns }